import { all, put, takeEvery, select, fork } from 'redux-saga/effects'

import * as tutorialActions from './tutorial.actions'
import * as gameActions from './../Core/Game/game.actions'
import * as loaderActions from '../Core/Loader/loader.actions'
import * as pointsManagerActions from '../Mars/PointsManager/pointsManager.actions'
import * as audioActions from '../Core/Game/AudioContainer/audio.actions'
import * as mapActions from '../Mars/Map/map.actions'
import * as indicatorsActions from '../Mars/Indicators/indicators.actions'
import * as preloaderActions from '../Core/Preloader/preloader.actions'

import * as mapSelectors from '../Mars/Map/map.selectors'
import * as firebaseSelectors from '../Core/Firebase/firebase.selectors'
import * as tutorialSelectors from './tutorial.selectors'
import * as tutorialConstants from './tutorial.constants'
import * as gameSelectors from './../Core/Game/game.selectors'

import * as questionsConstants from './questions.constants'
import * as audio from '../Core/Game/AudioContainer/audio.sagas'

import { i18n } from '../Core'

import AcademyScreen from './AcademyScreen'
import TutorialMapScreen from './TutorialMapScreen'
import TutorialMiningScreen from './TutorialMiningScreen'
import TutorialBuildMessageScreen from './TutorialMapScreen/TutorialBuildMessageScreen'
import TutorialCreateDebateMessageScreen from './TutorialMapScreen/TutorialCreateDebateMessageScreen'
import TutorialBattlesMessageScreen from './TutorialMapScreen/TutorialBattlesMessageScreen'
import TutorialMiningSelectContainer from './TutorialMiningScreen/MiningSelectScreen'
import TutorialMiningAnswerQuestionContainer from './TutorialMiningScreen/AnswerQuestionsScreen/TutorialMiningAnswerQuestionContainer'
import TutorialMiningCreateQuestionContainer from './TutorialMiningScreen/CreateQuestionScreen/TutorialMiningCreateQuestionContainer'
import TutorialMiningVoteQuestionContainer from './TutorialMiningScreen/VoteQuestionScreen/TutorialMiningVoteQuestionContainer'
import TutorialProfileScreen from './TutorialProfile/TutorialProfileScreen'
import TutorialTilePopup from './TutorialTilePopup'
import TutorialMiningChangePhasePopup from './TutorialMiningChangePhasePopup'
import TutorialPhase1Screen from './TutorialPhase1Screen'
import TutorialStartBattle from './TutorialStartBattle'
import TutorialAnswerBattle from './TutorialAnswerBattle'
import TutorialBattleResume from './TutorialBattleResume'
import TutorialCheckBattle from './TutorialCheckBattle'
import TutorialLastTurnPopup from './TutorialLastTurnPopup'
import VeredictTutorialScreen from './VeredictTutorialScreen'
import FinishTutorialScreen from './FinishTutorialScreen'
import TutorialEndPopup from './TutorialEndPopup'

import * as mapUtils from '../Mars/Util/util'

import * as tutorialUtil from './tutorialUtil'

function* init() {
  yield put(gameActions.startSceneChange('map_scene'))
  yield loadComponents()
}

function preloadSounds({ sounds = [] }, { sounds: storyLineSounds = {} }) {
  let toPreload = {}

  for (let id of sounds) {
    const sound = storyLineSounds[id]
    let url = sound.urlTemplate
    toPreload = {
      ...toPreload,
      [id]: { id, type: 'sound', url },
    }
  }
  return toPreload
}
export function* loadComponents() {
  const components = {
    AcademyScreen,
    TutorialMapScreen,
    TutorialMiningScreen,
    TutorialBuildMessageScreen,
    VeredictTutorialScreen,
    FinishTutorialScreen,
    TutorialEndPopup,
    TutorialCreateDebateMessageScreen,
    TutorialBattlesMessageScreen,
    TutorialMiningSelectContainer,
    TutorialMiningAnswerQuestionContainer,
    TutorialMiningCreateQuestionContainer,
    TutorialMiningVoteQuestionContainer,
    TutorialProfileScreen,
    TutorialTilePopup,
    TutorialMiningChangePhasePopup,
    TutorialPhase1Screen,
    TutorialStartBattle,
    TutorialAnswerBattle,
    TutorialBattleResume,
    TutorialCheckBattle,
    TutorialLastTurnPopup,
  }

  yield put(gameActions.registerComponents(components))
}

function* initTutorialUrl() {
  const [, tutorial, lang] = window.location.pathname.split('/')
  if (tutorial !== 'tutorial') return
  const sceneId = 'map_scene'
  let isCurrent = true
  yield put(gameActions.startSceneChange(sceneId))
  const storyLine = yield select(gameSelectors.getStoryLine)
  let toPreload = storyLine.commonPreload
  toPreload = {
    ...toPreload,
    ...preloadSounds(storyLine.scenes[sceneId], storyLine),
  }
  yield put(
    preloaderActions.startPreload({
      toPreload,
      isCurrent,
      sceneId,
    })
  )
  yield put(loaderActions.removeAllLoaders())
  yield put(gameActions.startSceneChange('map_scene'))
  yield put(tutorialActions.initTutorial())
  yield put(
    tutorialActions.setUserInfoFake({
      licenseData: {
        lang,
      },
    })
  )
  yield put(tutorialActions.loadI18NMessages())
}

function* initTutorialSagas() {
  yield put(tutorialActions.setConfidentialNumber())
  yield put(gameActions.setScreens(['academy_screen']))
}

function* endTutorialSagas() {
  const playerData = yield select(firebaseSelectors.getPlayerData)

  let nextScreen = ''
  switch (playerData.phase) {
    case 0:
      nextScreen = 'phase0_screen'
      break
    case 1:
      nextScreen = 'phase1_screen'
      break
    case 2:
      nextScreen = 'map_screen'
      break
    case 3:
      nextScreen = 'map_screen'
      break
    default:
      nextScreen = 'phase1_screen'
  }
  yield put(gameActions.setScreens([nextScreen]))
}

function* initDebate() {
  const translations = yield select(i18n.selectors.getI18nMessages)
  if (translations) {
    let debates = [
      {
        question: translations['tutorial.turn2.debate_screen.how_to_impugnate'],
        choices: [
          {
            _id: '5c8f49ef35407b000f6dfd9a',
            text: translations['tutorial.turn2.debate_screen.answer1'],
            isCorrect: false,
            key: 1,
          },
          {
            _id: '5c8f49ef35407b000f6dfd99',
            text: translations['tutorial.turn2.debate_screen.answer2'],
            isCorrect: true,
            key: 2,
          },
          {
            _id: '5c8f49ef35407b000f6dfd98',
            text: translations['tutorial.turn2.debate_screen.answer3'],
            isCorrect: false,
            key: 3,
          },
        ],
        dispute: {
          cause: 'BAD_TOPIC',
          debate: [
            {
              debateText: translations['tutorial.turn2.debate_screen.cause'],
            },
            {
              vote: 'negative',
              debateText: translations['tutorial.turn2.debate_screen.msg1'],
              authorLicenseId: '#00182',
            },
            {
              vote: 'negative',
              debateText: translations['tutorial.turn2.debate_screen.msg2'],
              authorLicenseId: '#12980',
            },
            {
              vote: 'negative',
              debateText: translations['tutorial.turn2.debate_screen.msg3'],
              authorLicenseId: '#10039',
            },
          ],
        },
        right: true,
        currency: 'antimatter',
        reward: 0,
      },
    ]
    yield put(tutorialActions.setVoteQuestion(debates[0]))
    yield put(tutorialActions.setDebatesInfo(debates))
  }
}

function* goToSagas() {
  // const { phase, turn } = action.data

  const userData = yield select(tutorialSelectors.getUserData)
  const { phase, turn, coins } = userData
  yield put(audioActions.removeHowlAudio())
  yield put(audioActions.playHowlAudio(phase))
  // todo split in sessions too
  // TURN 1
  if (turn == 1) {
    yield put(tutorialActions.modifyPrize(2))
    switch (phase) {
      case 2:
        yield put(gameActions.setScreens(['tutorial_build_message_screen', 'tutorial_map_screen']))
        break
      case 3:
        if (!coins) {
          yield put(tutorialActions.addCoins(4))
        }
        yield put(gameActions.setScreens(['tutorial_map_screen']))
        yield put(tutorialActions.showIndicators())
        yield put(tutorialActions.setAvailableBuildings(['home']))
        yield put(
          tutorialActions.showMessage({
            show: true,
            message: 'tutorial.common_texts.build',
          })
        )
        break
    }
    // TURN 2
  } else if (turn == 2) {
    yield put(tutorialActions.modifyPrize(4))
    switch (phase) {
      case 1:
        yield put(tutorialActions.hideMessage())
        yield put(gameActions.setScreens(['tutorial_phase1_screen']))
        break
      case 2:
        yield put(tutorialActions.hideMessage())
        yield initDebate()
        yield put(
          gameActions.setScreens(['tutorial_create_debate_message_screen', 'tutorial_map_screen'])
        )
        yield put(
          tutorialActions.setMapUI({
            indicators: true,
            nextTurnButton: false,
          })
        )
        yield put(
          tutorialActions.setMiningUI({
            mining: {
              create: true,
              answer: true,
            },
          })
        )
        yield put(
          tutorialActions.setCountersData({
            qu_t: 1,
            qu_tot: 1,
            qu_xt: 1,
            an_t: 6,
            an_tot: 6,
            an_xt: 6,
          })
        )
        break
      case 3:
        if (!coins) {
          yield put(tutorialActions.addCoins(4))
        }
        yield put(gameActions.setScreens(['tutorial_map_screen']))
        yield put(tutorialActions.showIndicators())
        yield put(
          tutorialActions.showMessage({
            show: true,
            message: 'tutorial.common_texts.build_all_types',
          })
        )
        break
    }
  } else if (turn == 3) {
    yield put(tutorialActions.modifyPrize(4))
    switch (phase) {
      case 1:
        yield put(tutorialActions.hideMessage())
        yield put(gameActions.setScreens(['tutorial_phase1_screen']))
        yield put(tutorialActions.setPhase1HideUI({ tab_quarry: false }))
        break
      case 2:
        yield put(tutorialActions.hideMessage())
        yield put(
          gameActions.setScreens(['tutorial_battles_message_screen', 'tutorial_map_screen'])
        )
        yield put(
          tutorialActions.setMapUI({
            userShield: true,
            indicators: true,
            nextTurnButton: false,
          })
        )
        yield put(
          tutorialActions.setMiningUI({
            mining: {
              create: true,
              answer: true,
              dispute: true,
              settingsButton: false,
              helpButton: false,
              mapButton: true,
            },
          })
        )
        yield put(tutorialActions.modifyDisputesAmount(0))
        yield put(
          tutorialActions.setCountersData({
            qu_t: 1,
            qu_tot: 1,
            qu_xt: 1,
            an_t: 5,
            an_tot: 5,
            an_xt: 5,
          })
        )
        break
      case 3:
        yield put(tutorialActions.hideMessage())
        yield put(gameActions.setScreens(['tutorial_map_screen']))
        yield put(
          tutorialActions.setMapUI({
            indicators: true,
            ranking: true,
          })
        )
        yield put(
          tutorialActions.showMessage({
            show: true,
            message: 'tutorial.common_texts.buildT3',
          })
        )
        yield put(tutorialActions.showIndicators())
        yield put(
          tutorialActions.setAvailableBuildings([
            'home',
            'windmill',
            'solar_panel',
            'oxygen_globe',
            'water_treatment_plant',
            'farm',
            'park',
            'spa',
            'gym',
            'social_club',
            'disco',
            'audience',
          ])
        )
        break
    }
  } else if (turn == 4) {
    yield put(tutorialActions.setDebatesInfo([]))
    yield put(tutorialActions.setBattle(tutorialConstants.battleOne))
    yield put(tutorialActions.modifyPrize(8))
    switch (phase) {
      case 1: {
        yield put(tutorialActions.hideMessage())
        yield put(
          tutorialActions.setPhase1HideUI({
            tab_battles: false,
            tab_quarry: false,
            tab_mis: false,
          })
        )
        yield put(gameActions.setScreens(['tutorial_phase1_screen']))
        const ranking = yield select(tutorialSelectors.getPlayerRanking)
        const activities = []
        activities.push({
          type: 'LEADER',
          data: { licenseId: ranking[0].licenseId, name: ranking[0].colonyName },
        })
        activities.push({
          type: 'BATTLE_WON',
          data: {
            winnerId: '5c934d95fdc4bc00134da4e5',
            loserId: '5c9357ab45e8b90011195247',
            coins: 2,
          },
        })
        activities.push({
          type: 'BATTLE_LOST',
          data: {
            winnerId: '123456789012345678901235',
            loserId: '5c9357ab45e8b90011195247',
            coins: 2,
            buildingName: 'windmill',
            buildingLevel: 1,
          },
        })
        yield put(tutorialActions.setActivity(activities))
        break
      }
      case 2:
        yield put(tutorialActions.hideMessage())
        yield put(gameActions.setScreens(['tutorial_map_screen']))
        yield put(
          tutorialActions.setMapUI({
            indicators: true,
            userShield: true,
            nextTurnButton: false,
            ranking: true,
          })
        )
        yield put(
          tutorialActions.setMiningUI({
            mining: {
              create: true,
              answer: true,
              dispute: true,
              settingsButton: false,
              helpButton: false,
              mapButton: true,
            },
          })
        )
        yield put(
          tutorialActions.setCountersData({
            qu_t: 1,
            qu_tot: 1,
            qu_xt: 1,
            an_t: 5,
            an_tot: 5,
            an_xt: 5,
          })
        )
        break
      case 3:
        yield put(tutorialActions.hideMessage())
        yield put(gameActions.setScreens(['tutorial_map_screen']))
        yield put(
          tutorialActions.showMessage({
            show: true,
            message: 'tutorial.common_texts.buildT2',
          })
        )
        yield put(tutorialActions.showIndicators())
        yield put(
          tutorialActions.setAvailableBuildings([
            'home',
            'windmill',
            'solar_panel',
            'oxygen_globe',
            'water_treatment_plant',
            'farm',
            'park',
            'spa',
            'gym',
            'social_club',
            'disco',
            'audience',
          ])
        )
        break
    }
  } else if (turn == 5) {
    yield put(tutorialActions.hideMessage())
    yield put(gameActions.setScreens(['finish_tutorial_screen']))
  }
}

function* showTutorialMessages() {
  const turn = yield select(tutorialSelectors.getTurn)
  const phase = yield select(tutorialSelectors.getCurrentPhase)
  const { attackSuccess } = yield select(tutorialSelectors.getTutorial)

  if (turn == 1) {
    switch (phase) {
      case 2:
        yield put(
          tutorialActions.showMessage({
            show: true,
            message: 'tutorial.common_texts.enter',
          })
        )
        break
      case 3:
        yield put(
          tutorialActions.showMessage({
            show: true,
            message: 'tutorial.common_texts.build',
          })
        )
        break
    }
  } else if (turn == 2) {
    switch (phase) {
      case 2:
        yield put(
          tutorialActions.showMessage({
            show: true,
            message: 'tutorial.common_texts.enter',
          })
        )
        break
      case 3:
        yield put(
          tutorialActions.showMessage({
            show: true,
            message: 'tutorial.common_texts.build_all_types',
          })
        )
        break
    }
  } else if (turn == 3) {
    switch (phase) {
      case 2:
        yield put(
          tutorialActions.showMessage({
            show: true,
            message: 'tutorial.common_texts.profile',
          })
        )
        break
      case 3:
        if (!attackSuccess) {
          yield put(
            tutorialActions.showMessage({
              show: true,
              message: 'tutorial.common_texts.buildT3',
            })
          )
        }
        break
    }
  } else if (turn == 4) {
    switch (phase) {
      case 3:
        yield put(
          tutorialActions.showMessage({
            show: true,
            message: 'tutorial.common_texts.buildT2',
          })
        )
        break
    }
  }
}

function* clickTileSagas() {
  const selectedBuilding = yield select(tutorialSelectors.getBuildingSelected)

  const currentPhase = yield select(tutorialSelectors.getCurrentPhase)

  if (selectedBuilding && currentPhase == 2 && selectedBuilding.type == 'mine') {
    yield put(tutorialActions.addScreen('mining_screen'))
    yield put(tutorialActions.hideMessage())
  } else {
    yield put(audioActions.playHowlAudio('button_click'))
    yield put(tutorialActions.addPopup('tile_popup'))
  }
}

/**
 * Check side effect of close screen in tutorial screens
 * @param {Object} action
 */
function* removeScreenFinishSagas(action) {
  const screenId = action.data
  const onTutorial = yield select(tutorialSelectors.isTutorialMode)
  const visitorMap = yield select(tutorialSelectors.getVisitorMap)

  if (onTutorial) {
    switch (screenId) {
      case 'tutorial_build_message_screen':
      case 'tutorial_create_debate_message_screen':
        yield put(
          tutorialActions.showMessage({
            show: true,
            message: 'tutorial.common_texts.enter',
          })
        )
        break
      case 'tutorial_battles_message_screen':
        yield put(
          tutorialActions.showMessage({
            show: true,
            message: 'tutorial.common_texts.profile',
          })
        )
        break
      case 'ranking_screen': {
        if (!visitorMap.mapId) {
          yield put(
            tutorialActions.setMapUI({
              ranking: true,
            })
          )
          yield showTutorialMessages()
        }
        break
      }
      case 'tutorial_mining_screen':
        yield showTutorialMessages()
        break
    }
  }
}

function* answerQuestionSagas(action) {
  const { choices, selectedKey } = action.data
  const prizeCoins = yield select(tutorialSelectors.getPrizeCoins)
  const correct = choices[selectedKey - 1].isCorrect
  const coins = correct ? prizeCoins : 0
  yield put(
    tutorialActions.setFeedBack({
      answerId: selectedKey,
      correct,
      coins,
    })
  )
  yield put(
    pointsManagerActions.setPointsData({ value: '+' + coins, icon: 'icon-coin', style: {} })
  )

  if (correct) {
    yield put(tutorialActions.addCoins(coins))
  }

  // Also updates the questions answered counter
  const counters = yield select(tutorialSelectors.getCountersData)
  yield put(
    tutorialActions.setCountersData({
      an_t: counters.an_t - 1,
    })
  )
}

function* createQuestionSagas() {
  const prizeCoins = yield select(tutorialSelectors.getPrizeCoins)
  yield put(
    pointsManagerActions.setPointsData({ value: '+' + prizeCoins, icon: 'icon-coin', style: {} })
  )
  yield put(tutorialActions.addCoins(prizeCoins))
  yield put(audioActions.playHowlAudio('click'))

  // Also updates the questions answered counter
  const counters = yield select(tutorialSelectors.getCountersData)
  yield put(
    tutorialActions.setCountersData({
      qu_t: counters.qu_t - 1,
    })
  )
  yield put(
    tutorialActions.setMiningUI({
      mining: {
        create: true,
        answer: true,
        dispute: true,
      },
    })
  )

  yield put(tutorialActions.endFlow())
}

function* voteQuestionSagas() {
  const prizeCoins = yield select(tutorialSelectors.getPrizeCoins)
  yield put(
    pointsManagerActions.setPointsData({ value: '+' + prizeCoins, icon: 'icon-coin', style: {} })
  )
  const currentDisputes = yield select(tutorialSelectors.getTotalDisputes)
  yield put(tutorialActions.addCoins(prizeCoins))
  yield put(audioActions.playHowlAudio('click'))
  yield put(tutorialActions.modifyDisputesAmount(currentDisputes - 1))
  yield put(tutorialActions.endFlow())
}

function* endFlowSagas() {
  let counters = yield select(tutorialSelectors.getCountersData)
  const currentDisputes = yield select(tutorialSelectors.getTotalDisputes)
  let canGoToNextPhase = counters.qu_t == 0 && counters.an_t == 0 && currentDisputes == 0

  if (canGoToNextPhase) {
    yield put(
      tutorialActions.setMiningUI({
        mining: {
          create: false,
          answer: false,
          dispute: false,
          nextTurnButton: true,
        },
      })
    )
  }
  yield put(tutorialActions.changeMiningScreen('mining_select_screen'))
}

function* updateQuestion() {
  const { an_t, an_xt } = yield select(tutorialSelectors.getCountersData)
  const questionIndex = an_xt - an_t
  // sumar turn * 7 -1

  yield put(tutorialActions.setCurrentQuestion(questionIndex))
}

function* changeMiningScreenSagas(action) {
  yield put(tutorialActions.hideMessage())
  let miningId = `tutorial_${action.data}`

  if (miningId === 'tutorial_mining_default') {
    miningId = 'tutorial_mining_select_screen'
  }

  switch (miningId) {
    case 'tutorial_mining_select_screen':
      yield updateQuestion()
      break
    // case "tutorial_answer_question_screen":
    // case "tutorial_create_question_screen":
    //   break
  }

  yield put(tutorialActions.changeMiningScreenSuccess(miningId))
}

function* createBuildingSagas(action) {
  // TODO CHECK IF USER HAS ENOUGH COINS

  const indicators = yield select(tutorialSelectors.getIndicators)
  const coins = indicators.find((ind) => ind.id == 'coins').value
  const buildMessages = ['tutorial.common_texts.build']

  let buildingData = action.data
  if (coins >= buildingData.pricePerLevel[0]) {
    const tile = yield select(mapSelectors.getSelectedTile)

    const building = {
      name: buildingData.id ? buildingData.id : buildingData.name,
      type: buildingData.type,
      level: buildingData.isFree && buildingData.level ? buildingData.level : 1,
      built: buildingData.isFree ? true : false,
      evolving: false,
      destroying: false,
      q: tile.q,
      r: tile.r,
      production: buildingData.productionAmount[0],
      multiplier: 1,
      price: buildingData.isFree ? 0 : buildingData.pricePerLevel[0],
      isFree: buildingData.isFree ? buildingData.isFree : false,
    }
    let value = buildingData.isFree ? 0 : buildingData.pricePerLevel[0]
    // Feedback
    yield put(
      pointsManagerActions.setPointsData({ value: '-' + value, icon: 'icon-coin', style: {} })
    )
    yield put(tutorialActions.addCoins(value * -1))
    yield put(audioActions.playHowlAudio('landing'))
    const currentMessage = yield select(tutorialSelectors.getTutorialMessage)

    if (buildMessages.includes(currentMessage.message) && currentMessage.show) {
      yield put(tutorialActions.hideMessage())
    }

    yield put(tutorialActions.createBuildingSuccess(building))
  } else {
    yield put(audioActions.playHowlAudio('wrong_answer'))
  }

  // If not have enought coins
  // yield put(audioActions.playHowlAudio('wrong_answer'))

  // Check and update goals
  yield checkGoalsAndEnableButtons()
}

function* upgradeBuildingSagas(action) {
  // TODO CHECK IF USER HAS ENOUGH COINS

  const indicators = yield select(tutorialSelectors.getIndicators)
  const coins = indicators.find((ind) => ind.id == 'coins').value
  const buildings = yield select(mapSelectors.getBuildings)

  let buildingData = action.data
  let buildingConfig = buildings[buildingData.name]

  const maxIndex = buildingConfig.maxLevel - 1
  const currentIndex = buildingData.level < maxIndex ? buildingData.level : maxIndex

  if (coins >= buildingConfig.pricePerLevel[currentIndex]) {
    const tile = yield select(mapSelectors.getSelectedTile)

    let buildingKey = `${tile.q}_${tile.r}`
    let prize = buildingData.isFree ? 0 : buildingConfig.pricePerLevel[currentIndex]
    const turn = yield select(tutorialSelectors.getTurn)
    const TURNS_TO_EVOLVE = { 1: 1, 2: 2, 3: 0 }

    let payload = { id: buildingKey, evolving: turn + TURNS_TO_EVOLVE[buildingData.level] }

    // Feedback
    yield put(
      pointsManagerActions.setPointsData({ value: '-' + prize, icon: 'icon-coin', style: {} })
    )
    yield put(tutorialActions.addCoins(prize * -1))
    yield put(audioActions.playHowlAudio('upgrade'))
    yield put(tutorialActions.upgradeBuildingSuccess(payload))
  } else {
    yield put(audioActions.playHowlAudio('wrong_answer'))
  }

  // If not have enought coins
  // yield put(audioActions.playHowlAudio('wrong_answer'))

  // Check and update goals
  yield checkGoalsAndEnableButtons()
}

function* checkGoalsAndEnableButtons() {
  const phase = yield select(tutorialSelectors.getCurrentPhase)
  const turn = yield select(tutorialSelectors.getTurn)
  const currentMessage = yield select(tutorialSelectors.getTutorialMessage)
  const buildMessages = ['tutorial.common_texts.build', 'tutorial.common_texts.build_all_types']

  if (turn == 1) {
    if (phase == 3) {
      const { nextTurnButton } = yield select(tutorialSelectors.getMapUI)

      // enable nextTurnButton when build
      if (!nextTurnButton) {
        yield put(
          tutorialActions.setMapUI({
            indicators: true,
            nextTurnButton: true,
          })
        )
      }
    }
  } else if (turn == 2) {
    if (phase == 3) {
      const { nextTurnButton } = yield select(tutorialSelectors.getMapUI)
      const { buildings } = yield select(tutorialSelectors.getUserMap)
      const types = yield select(mapSelectors.getBuildingTypes)
      const indicators = yield select(tutorialSelectors.getIndicators)
      const coins = indicators.find((ind) => ind.id == 'coins').value
      delete types.debris
      let arrayTypes = Object.keys(types)

      Object.entries(buildings).map(([, value]) => {
        const i = arrayTypes.indexOf(value.type)
        if (i > -1) arrayTypes.splice(i, 1)
      })

      if (!nextTurnButton && (arrayTypes.length === 0 || coins < 2)) {
        yield put(tutorialActions.setMapUI({ nextTurnButton: true }))
        if (
          currentMessage.message == 'tutorial.common_texts.build_all_types' &&
          currentMessage.show
        ) {
          yield put(tutorialActions.hideMessage())
        }
        if (coins < 2) {
          yield put(
            tutorialActions.showMessage({
              show: true,
              message: 'tutorial.common_texts.fail_goal_build_all',
            })
          )
        }
      }
    }
  } else if (turn == 3) {
    if (phase == 3) {
      const { nextTurnButton } = yield select(tutorialSelectors.getMapUI)
      const { attackSuccess } = yield select(tutorialSelectors.getTutorial)

      if (attackSuccess && !nextTurnButton) {
        yield put(
          tutorialActions.setMapUI({
            nextTurnButton: true,
          })
        )
        if (buildMessages.includes(currentMessage.message) && currentMessage.show) {
          yield put(tutorialActions.hideMessage())
        }
      }
    }
  } else if (turn == 4) {
    if (phase == 3) {
      const { nextTurnButton } = yield select(tutorialSelectors.getMapUI)

      if (!nextTurnButton) {
        yield put(
          tutorialActions.setMapUI({
            nextTurnButton: true,
          })
        )
        if (buildMessages.includes(currentMessage.message) && currentMessage.show) {
          yield put(tutorialActions.hideMessage())
        }
      }
    }
  }
}

function* removePopupSagas(action) {
  const popupId = action.data
  // Si no existe el popup correspondiente del tutorial petará
  yield put(gameActions.removePopup(`tutorial_${popupId}`))
}

function* addPopupSagas(action) {
  const popupId = action.data

  // Si no existe el popup correspondiente del tutorial no hará nada
  yield put(gameActions.addPopup(`tutorial_${popupId}`))
}

function* addScreenSagas(action) {
  const screenId = action.data

  yield put(gameActions.addScreen(`tutorial_${screenId}`))

  switch (screenId) {
    case 'battle_screen': {
      yield put(tutorialActions.startCurrentBattle())
      break
    }
    case 'mining_screen': {
      yield updateQuestion()
      yield put(tutorialActions.hideMessage())
      break
    }
  }
}

function* removeScreenSagas(action) {
  const screenId = action.data

  yield put(gameActions.removeScreen(`tutorial_${screenId}`))
  const oldMessage = yield select(tutorialSelectors.getOldMessageId)

  switch (screenId) {
    case 'mining_screen':
    case 'ranking_screen': {
      yield put(
        tutorialActions.showMessage({
          show: true,
          message: oldMessage,
        })
      )
      break
    }
    case 'battle_screen':
      yield checkGoalsAndEnableButtons()
      break
  }
}

function* getProfileBattles() {
  yield put(tutorialActions.addScreen('profile_screen'))
  yield put(tutorialActions.hideMessage())
}

function* nextPhaseSagas() {
  const turn = yield select(tutorialSelectors.getTurn)
  const phase = yield select(tutorialSelectors.getCurrentPhase)
  yield put(tutorialActions.goTo({ phase: (phase % 3) + 1, turn: turn }))
}

function* nextTurnSagas() {
  const userMap = yield select(tutorialSelectors.getUserMap)
  const turn = yield select(tutorialSelectors.getTurn)
  let buildings = Object.assign({}, userMap.buildings)
  let storyBuildings = yield select(mapSelectors.getBuildings)

  //MODIFY BUILDING
  let modifiedBuildings = {}
  Object.keys(buildings).map((key) => {
    let building = buildings[key]

    if (building.built == false) {
      building.built = true
    }

    if (building.evolving != false && building.evolving <= turn + 1) {
      building.evolving = false
      building.level = building.level + 1
    }

    building.production = storyBuildings[building.name].productionAmount[building.level - 1]
    building.multiplier =
      mapUtils.getSameNeightbors(building, Object.values(buildings)).length > 1 ? 2 : 1

    modifiedBuildings[key] = building
  })

  const updatedBuildings = { ...buildings, ...modifiedBuildings }
  let indicators = tutorialUtil.getBuildingsIndicators(updatedBuildings)
  let oldIndicators = yield select(tutorialSelectors.getIndicatorsObject)
  let modifiedOldIndicators = {}
  let userDataModification = { ...indicators }

  Object.values(oldIndicators).map((ind) => (modifiedOldIndicators[ind.id] = ind.value))
  Object.keys(indicators).map(
    (key) => (userDataModification[`${key}Old`] = modifiedOldIndicators[key])
  )

  userDataModification = {
    ...userDataModification,
    settlers: tutorialUtil.getUserSettlers(userDataModification),
    cityLevel: tutorialUtil.calculateCityLevel(
      Object.values(buildings).length,
      userDataModification.cityLevel
    ),
    coins: modifiedOldIndicators.coins,
  }

  yield put(tutorialActions.modifyBuildings(modifiedBuildings))
  yield put(tutorialActions.modifyIndicators(indicators))
  yield put(tutorialActions.setUserData(userDataModification))
  yield put(
    tutorialActions.goTo({
      phase: 1,
      turn: turn + 1,
    })
  )

  yield put(tutorialActions.setCurrentUser({ settlers: userDataModification.settlers }))
  const currentPosition = yield select(tutorialSelectors.getCurrentPosition)
  yield put(tutorialActions.setCurrentUser({ position: currentPosition }))
}

function* originalAddScreen(action) {
  const screenId = action.data
  const onTutorial = yield select(tutorialSelectors.isTutorialMode)

  if (onTutorial) {
    switch (screenId) {
      case 'ranking_screen': {
        yield put(tutorialActions.hideMessage())
        yield put(
          tutorialActions.setMapUI({
            ranking: false,
          })
        )
        break
      }
    }
  }
}

function* giveUp() {
  const { phase, turn } = yield select(tutorialSelectors.getUserData)

  if (turn != 4 && phase != 1) {
    yield put(tutorialActions.removeScreen('battle_screen'))
  }
}

function* checkSelectTab(action) {
  const tabIndex = action.data
  const turn = yield select(tutorialSelectors.getTurn)
  if (tabIndex == -1) {
    yield put(tutorialActions.goTo({ turn: turn, phase: 2 }))
  }
}

function* checkLastQuestion() {
  const questionNumber = yield select(tutorialSelectors.getBattlequestionNum)

  if (questionNumber == 5) {
    yield put(tutorialActions.endCurrentBattle())
    yield put(tutorialActions.removeScreen('battle_screen'))
    yield put(tutorialActions.addScreen('battle_resume_screen'))
  }
}

function* loadVisitorMap(action) {
  const uid = action.data

  const visitorIndicators = tutorialConstants.visitorIndicators
  const allVisitors = yield select(tutorialSelectors.getAllVisitorsMap)
  const visitorMap = allVisitors[uid]
  let currentIndicators = tutorialUtil.getBuildingsIndicators(visitorMap.buildings)
  let realIndicators = { ...visitorIndicators, ...currentIndicators }
  yield put(mapActions.clearSprites())
  yield put(tutorialActions.setVisitorMap({ ...visitorMap, visitorId: uid }))
  yield put(indicatorsActions.setVisitorIndicators(realIndicators))
  // yield put(activityActions.loadActivityDataVisitingPlayers(uid))
}

function* addScreenFinish(action) {
  const data = action.data
  if (data === 'tutorial_mining_screen') {
    const { phase, turn } = yield select(tutorialSelectors.getUserData)
    if (turn == 1 && phase == 2) {
      yield put(
        tutorialActions.showMessage({
          show: true,
          message: 'tutorial.common_texts.answer_question',
        })
      )
    }
  }
}

function* createBattleSagas(action) {
  let payload = { ...action.data }
  let currentUser = yield select(tutorialSelectors.getCurrentUser)
  let currentSession = (yield select(tutorialSelectors.getUserData)).phase
  let questions = Object.keys(questionsConstants.questions)
  let randomPool = tutorialUtil.getRandomIndexPool(questions, 5)

  let battleModel = {
    id: '11234567',
    players: [currentUser.licenseId, payload.rivalId],
    info: {
      hits: 0,
      fails: 0,
      question: 1,
    },
    questions: [
      questions[randomPool[0]],
      questions[randomPool[1]],
      questions[randomPool[2]],
      questions[randomPool[3]],
      questions[randomPool[4]],
    ],
    resolvedForAttacker: true,
    resolvedForDefender: false,
    deleted: false,
    createdBy: currentUser.licenseId,
    rivalId: payload.rivalId,
    groupId: '5c9c65a8b8431b00113caa58',
    building: { ...payload.battleParameters },
    session: currentSession,
    results: {
      [currentUser.licenseId]: {
        finished: false,
        startTime: 1553766247383.0,
        endTime: 1553766279884.0,
        [questions[randomPool[0]]]: {
          selectedKey: 3,
          right: false,
          correctChoice: 1,
        },
        [questions[randomPool[1]]]: {
          selectedKey: 1,
          right: false,
          correctChoice: 3,
        },
        [questions[randomPool[2]]]: {
          selectedKey: 3,
          right: false,
          correctChoice: 1,
        },
        [questions[randomPool[3]]]: {
          selectedKey: 3,
          right: false,
          correctChoice: 2,
        },
        [questions[randomPool[4]]]: {
          selectedKey: 3,
          right: false,
          correctChoice: 1,
        },
      },
    },
  }

  yield put(tutorialActions.setBattle(battleModel))
  yield put(tutorialActions.addScreen('start_battle_screen'))
  yield put(
    tutorialActions.modifyVisitorBuilding({
      building: { ...payload.battleParameters, blocked: true },
      uid: payload.rivalId,
    })
  )
  yield put(tutorialActions.setCurrentUser({ batd: currentUser.batd + 1 }))
}

export function* sagas() {
  yield all([
    init(),
    initTutorialUrl(),
    takeEvery(tutorialActions.INIT_TUTORIAL_URL, initTutorialUrl),
    takeEvery(tutorialActions.INIT_TUTORIAL, initTutorialSagas),
    takeEvery(tutorialActions.END_TUTORIAL, endTutorialSagas),
    takeEvery(tutorialActions.GO_TO, goToSagas),
    takeEvery(tutorialActions.CLICK_TILE, clickTileSagas),
    takeEvery(gameActions.REMOVE_SCREEN_FINISH, removeScreenFinishSagas),
    takeEvery(gameActions.ADD_SCREEN_FINISH, addScreenFinish),
    takeEvery(tutorialActions.ANSWER_QUESTION, answerQuestionSagas),
    takeEvery(tutorialActions.CREATE_QUESTION, createQuestionSagas),
    takeEvery(tutorialActions.CREATE_BATTLE, createBattleSagas),
    takeEvery(tutorialActions.VOTE_QUESTION, voteQuestionSagas),
    takeEvery(tutorialActions.END_FLOW, endFlowSagas),
    takeEvery(tutorialActions.CHANGE_MINING_SCREEN, changeMiningScreenSagas),
    takeEvery(tutorialActions.CREATE_BUILDING, createBuildingSagas),
    takeEvery(tutorialActions.UPGRADE_BUILDING, upgradeBuildingSagas),
    takeEvery(tutorialActions.REMOVE_POPUP, removePopupSagas),
    takeEvery(tutorialActions.ADD_POPUP, addPopupSagas),
    takeEvery(tutorialActions.ADD_SCREEN, addScreenSagas),
    takeEvery(tutorialActions.REMOVE_SCREEN, removeScreenSagas),
    takeEvery(tutorialActions.NEXT_PHASE, nextPhaseSagas),
    takeEvery(tutorialActions.NEXT_TURN, nextTurnSagas),
    takeEvery(tutorialActions.TRIGGER_SELECT_TAB, checkSelectTab),
    takeEvery(tutorialActions.GET_PROFILE_BATTLES, getProfileBattles),
    takeEvery(tutorialActions.ANSWER_BATTLE_QUESTION, checkLastQuestion),
    takeEvery(tutorialActions.GIVE_UP_BATTLE, giveUp),
    takeEvery(tutorialActions.LOAD_VISITOR_MAP, loadVisitorMap),
    takeEvery(gameActions.ADD_SCREEN_FINISH, originalAddScreen),
  ])
  yield fork(audio.sagas)
}
